import { Injectable } from '@angular/core';
import { CustomAuthService } from '../auth/custom-auth.service';
import { CrowdFlowMapService } from '../crowdflow/crowd-flow-map.service';
import { UAVMapService } from '../drones/service/uavmap.service';
import { MissionLogBookService } from '../mission-log-book/service/mission-log-book.service';
import { MissionsService } from '../mission/service/missions.service';
import { BuildingService } from '../smart-building/service/building.service';
import { DevicesService } from '../smart-building/service/devices.service';
import { CitizenReportService } from '../social-media/service/citizen-report.service';
import { SocialMediaSearchService } from '../social-media/service/social-media-search.service';
import { SocialMediaService } from '../social-media/service/social-media.service';
import { GlobalStateQuery } from '../state/global.appstate.query';
import { VehicleService } from '../vehicle/service/vehicle.service';
import { AppStateService } from './app-state.service';
import { NetworkService } from './network.service';
import { ServerSideProcessorService } from './server-side-processor.service';
import { take } from 'rxjs/operators';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SmAlertRuleService } from '../social-media/service/sm-alert-rule.service';
import { filterNilValue } from '@datorama/akita';
import { TimeSeriesHistoryService } from './time-series-history.service';
import { CrowdFlowUtilsService } from '../crowdflow/util/crowd-flow-utils.service';
import { UnitService } from '../unit/service/unit.service';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class DataLoadingService {

  constructor(private auth: CustomAuthService,
    private missionService: MissionsService,
    private logbookService: MissionLogBookService,
    private vehicleService: VehicleService,
    private unitService: UnitService,
    private uavVMapService: UAVMapService,
    /*Do not delete! Required for init of Websockets */
    private crowdFlowUtilsService: CrowdFlowUtilsService,
    private buildingService: BuildingService,
    private networkService: NetworkService,
    private devicesService: DevicesService,
    /*Do not delete! Required for init of Websockets */
    private socialMediaService: SocialMediaService,
    private appStateService: AppStateService,
    private citizenReportService: CitizenReportService,
    private globalStateQuery: GlobalStateQuery,
    private sspService: ServerSideProcessorService,
    private socialMediaSearchService: SocialMediaSearchService,
    private smAlertRuleService: SmAlertRuleService,
    private timeSeriesHistoryService: TimeSeriesHistoryService) { }

  loadAllData() {
    this.auth.envConfig$.pipe(filterNilValue(),take(1)).subscribe(envConfig => {
      this.logbookService.updateEntitiesUrl(envConfig.fiwareUrl);

      this.vehicleService.updateEntitiesUrl(envConfig.fiwareUrl);
      this.vehicleService.getAll();

      this.unitService.updateEntitiesUrl(envConfig.fiwareUrl);
      this.unitService.getAll();

      this.missionService.updateEntitiesUrl(envConfig.fiwareUrl);
      // this.missionService.getAllForLast12Hours(); //call this function for last 12Hours data
      this.missionService.getAllForLast1Week();

      this.logbookService.getMaxItems(10, 'Alert');

      this.uavVMapService.updateEntitiesUrl(envConfig.fiwareUrl);
      this.uavVMapService.loadAll();

      this.devicesService.updateEntitiesUrl(envConfig.fiwareUrl);
      this.devicesService.getAll();

      this.buildingService.updateEntitiesUrl(envConfig.fiwareUrl);
      this.buildingService.getAll();

      this.citizenReportService.updateEntitiesUrl(envConfig.fiwareUrl);
      this.citizenReportService.getAll();

      this.smAlertRuleService.updateEntitiesUrl(envConfig.fiwareUrl);

      this.socialMediaService.updateEntitiesUrl(envConfig.fiwareUrl);
      this.socialMediaSearchService.updateEntitiesUrl(envConfig.fiwareUrl);

      this.timeSeriesHistoryService.updateEntitiesUrl(envConfig.timeSeriesDbUrl);
      this.crowdFlowUtilsService.updateEntitiesUrl(envConfig.fiwareUrl);
      this.sspService.updateEntitiesUrl(envConfig.inspireSSPUrl);
    });

  }
}
